import React, { useState } from "react";

const BlockedSites = ({ appData, updateAppData, extensionStatus }) => {
  const [newSite, setNewSite] = useState("");

  const addBlockedSite = () => {
    const site = newSite.trim().toLowerCase();

    if (!site) return;

    if (appData.blockedSites.includes(site)) {
      window.alert("This site is already in your block list");
      return;
    }

    updateAppData({
      blockedSites: [...appData.blockedSites, site],
    });

    setNewSite("");
  };

  const removeBlockedSite = (index) => {
    updateAppData({
      blockedSites: appData.blockedSites.filter((_, i) => i !== index),
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      addBlockedSite();
    }
  };

  const openExtensionRepo = () => {
    window.open("https://github.com/supersver/Deep-Focus-Extension", "_blank");
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
      <div className="flex items-center gap-2 mb-6">
        <i className="ph ph-shield-slash text-gray-700 text-xl"></i>
        <h2 className="text-xl font-bold text-gray-900">Blocked Websites</h2>
      </div>

      <div className="flex gap-3 mb-6">
        <div className="relative flex-1">
          <i className="ph ph-globe text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2"></i>
          <input
            type="text"
            value={newSite}
            onChange={(e) => setNewSite(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="e.g., twitter.com"
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all duration-200"
          />
        </div>
        <button
          onClick={addBlockedSite}
          className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2"
        >
          <i className="ph ph-plus text-sm"></i>
          Add Site
        </button>
      </div>

      <div className="space-y-3">
        {appData.blockedSites.length === 0 ? (
          <div className="text-center py-12">
            <i className="ph ph-shield-check text-gray-300 text-6xl mb-4"></i>
            <p className="text-gray-500 font-medium">No blocked sites yet</p>
            <p className="text-gray-400 text-sm">
              Add sites to block during focus sessions
            </p>
          </div>
        ) : (
          appData.blockedSites.map((site, index) => (
            <div
              key={index}
              className="flex justify-between items-center p-4 bg-red-50 border-2 border-red-200 rounded-xl transition-all duration-200 hover:shadow-md"
            >
              <div className="flex items-center gap-3">
                <i className="ph ph-globe text-red-500"></i>
                <span className="font-semibold text-red-900">{site}</span>
              </div>
              <button
                onClick={() => removeBlockedSite(index)}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                <i className="ph ph-trash text-sm"></i>
                Remove
              </button>
            </div>
          ))
        )}
      </div>

      <div className="mt-6 p-6 bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl">
        <div className="flex items-center gap-2 mb-2">
          <i className="ph ph-puzzle-piece text-blue-600 text-xl"></i>
          <h3 className="font-bold text-blue-800">Browser Extension</h3>
        </div>
        <p className="text-sm text-blue-700 mb-4 leading-relaxed">
          Website blocking is automatically enabled when the browser extension
          is installed and this app is running.
        </p>
        {extensionStatus ? (
          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 mb-4">
            <div className="flex items-center">
              <i className="ph ph-check-circle text-green-500 text-xl mr-3"></i>
              <span className="text-green-800 font-semibold">
                Extension connected! Website blocking is active.
              </span>
            </div>
          </div>
        ) : (
          <div className="flex gap-3">
            <button
              onClick={openExtensionRepo}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2"
            >
              <i className="ph ph-github-logo text-sm"></i>
              Get Extension
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockedSites;
